module.exports = __webpack_public_path__ + "img/ra-lin-logo.b3b6a79e.jpg";